<template>
  <!-- class="lg:flex flex-1" -->
  <div>
    <Nav />
    <toTopComponent />
    <contentsMainPage class="main" />
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/new/Nav.vue";
import toTopComponent from "@/components/toTopComponent.vue";
import contentsMainPage from "@/pages/contentsMall/contentsHanaPage.vue";
import Footer from "@/components/new/Footer.vue";

export default {
  name: "contentsMain",
  components: {
    contentsMainPage,
    Nav,
    toTopComponent,
    Footer,
  },
};
</script>

<style scoped>
.main {
  min-height: calc(100vh - var(--nav-height, 80px));
  margin-top: var(--nav-height, 80px);
}
</style>
